
import { t } from "../i18n/translations";
import { currencySymbol } from "../utils/currencyUtils";

export default function AddGiftScreen({
  lang, darkMode, user, userProfile,
  giftForm, setGiftForm,
  uploading, uploadProgress, autoFilling,
  prevViewingMember, prevViewingWishlist,
  viewingMember,
  // Setters
  setScreen, setActiveTab,
  setViewingMember, setViewingWishlist,
  setPrevViewingMember, setPrevViewingWishlist,
  // Functions
  saveGift, handleAutoFill, handlePhoto, deleteGift,
  fileRef,
}) {
  const tr = (key) => t(lang, key);

  return (
    <div>
      <h2 className="seccion-titulo">
        {giftForm.editId
          ? tr("editGift")
          : (prevViewingMember && prevViewingMember.id !== user?.uid)
            ? (lang === "es" ? "Agregar a mi Wishlu 🤩" : lang === "fi" ? "Lisää omaan Wishluuni 🤩" : "Add to my Wishlu 🤩")
            : tr("addAGift")}
      </h2>
      <div className="card">
        <div className="campo-grid" style={{ marginBottom: 16 }}>
          <div className="campo">
            <label className="campo-label">{tr("giftName")}</label>
            <input className="campo-input" placeholder={tr("giftNamePlaceholder")} value={giftForm.name} autoFocus
              onChange={function(e) { setGiftForm(function(f) { return { ...f, name: e.target.value }; }); }} />
          </div>
          <div className="campo">
            <label className="campo-label">{tr("price")}</label>
            <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
              <span style={{ fontSize: 13, color: "#999", flexShrink: 0 }}>{currencySymbol(userProfile?.currency || "USD")}</span>
              <input className="campo-input" style={{ flex: 1 }} placeholder={tr("pricePlaceholder")} value={giftForm.price} inputMode="decimal"
                onChange={function(e) { setGiftForm(function(f) { return { ...f, price: e.target.value.replace(/[^0-9.]/g, ""), currency: userProfile?.currency || "USD" }; }); }} />
            </div>
          </div>
        </div>
        <div className="campo">
          <label className="campo-label">{tr("purchaseLink")}</label>
          <div style={{ display: "flex", gap: 8 }}>
            <input className="campo-input" style={{ flex: 1 }} placeholder="https://store.com/product" value={giftForm.link}
              onChange={function(e) { setGiftForm(function(f) { return { ...f, link: e.target.value }; }); }} />
            <button className="btn btn-gris btn-sm" style={{ flexShrink: 0, whiteSpace: "nowrap" }} disabled={!giftForm.link || autoFilling}
              title={lang === "es" ? "Rellenar datos automáticamente desde el link" : lang === "fi" ? "Täytä tiedot automaattisesti linkistä" : "Auto-fill name & photo from link"}
              onClick={handleAutoFill}>
              {autoFilling ? (lang === "es" ? "Cargando…" : lang === "fi" ? "Ladataan…" : "Loading…") : "✨ Auto"}
            </button>
          </div>
        </div>
        <div className="campo">
          <label className="campo-label">{tr("description")}</label>
          <textarea className="campo-textarea" placeholder={tr("descPlaceholder")} value={giftForm.description}
            onChange={function(e) { setGiftForm(function(f) { return { ...f, description: e.target.value }; }); }} />
        </div>
        <div className="campo">
          <label className="campo-label">
            {tr("photo")} <span style={{ fontSize: 10, color: "#aaa", fontWeight: 400, textTransform: "none", letterSpacing: 0 }}>
              ({lang === "es" ? "opcional" : lang === "fi" ? "valinnainen" : "optional"})
            </span>
          </label>
          <div className={"foto-upload" + (giftForm.photoUrl ? " con-foto" : "")} onClick={function() { fileRef.current.click(); }}>
            <input ref={fileRef} type="file" accept="image/*" onChange={handlePhoto} style={{ display: "none" }} />
            {giftForm.photoUrl ? (
              <>
                <img src={giftForm.photoUrl} alt="preview" className="foto-preview" />
                <button className="boton-cambiar-foto" onClick={function(e) { e.stopPropagation(); fileRef.current.click(); }}>{tr("changePhoto")}</button>
              </>
            ) : (
              <>
                <div className="foto-icono">📷</div>
                <div className="foto-texto">{tr("tapPhoto")}</div>
              </>
            )}
          </div>
          {uploading && (
            <div>
              <div className="progreso-barra"><div className="progreso-fill" style={{ width: uploadProgress + "%" }}></div></div>
              <div className="progreso-texto">{tr("uploading")} {uploadProgress}%</div>
            </div>
          )}
        </div>
        {/* ── COOPERACIONES (solo en modo edición) ── */}
{giftForm.editId && (giftForm.cooperations || []).length > 0 && (
  <div style={{ borderTop: "1px solid " + (darkMode ? "#2e2e2e" : "#f0ece6"), marginTop: 16, paddingTop: 16 }}>
    <p style={{ fontSize: 11, color: "#aaa", textTransform: "uppercase", letterSpacing: "0.8px", marginBottom: 10 }}>
      💸 {lang === "es" ? "Cooperaciones" : lang === "fi" ? "Osallistumiset" : "Contributions"}
    </p>
    {(giftForm.cooperations || []).map(function(c, i) {
      return (
        <div key={c.uid} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
          <div style={{ flex: 1, fontSize: 13, color: darkMode ? "#e8e2d9" : "#1a1a1a" }}>{c.name}</div>
          <input
            className="campo-input"
            style={{ width: 80, textAlign: "right", margin: 0, padding: "6px 10px" }}
            inputMode="decimal"
            value={c.amount}
            onChange={function(e) {
              const val = e.target.value.replace(/[^0-9.]/g, "");
              setGiftForm(function(f) {
                const coops = f.cooperations.map(function(x, xi) {
                  return xi === i ? { ...x, amount: val } : x;
                });
                return { ...f, cooperations: coops };
              });
            }}
          />
          <button
            style={{ background: "none", border: "none", fontSize: 18, cursor: "pointer", color: "#c0392b", padding: "4px 6px", flexShrink: 0 }}
            onClick={function() {
              setGiftForm(function(f) {
                return { ...f, cooperations: f.cooperations.filter(function(_, xi) { return xi !== i; }) };
              });
            }}
          >🗑️</button>
        </div>
      );
    })}
  </div>
)}
        <div style={{ display: "flex", gap: 12, marginTop: 24 }}>
  <button className="btn btn-dorado" style={{ flex: 2 }} onClick={saveGift} disabled={uploading}>
    {uploading ? tr("uploading") : giftForm.editId ? tr("saveChanges") : tr("addAGift")}
  </button>
  {giftForm.editId && (
    <button className="btn btn-rojo" disabled={uploading} onClick={function() {
      if (window.confirm(lang === "es" ? "¿Eliminar " + (giftForm.name || "este regalo") + "?" : "Delete " + (giftForm.name || "this gift") + "?")) {
        deleteGift(giftForm.editId);
        if (prevViewingMember) {
          setViewingMember(prevViewingMember);
          setViewingWishlist(prevViewingWishlist);
          setPrevViewingMember(null);
          setPrevViewingWishlist(null);
          setScreen("profile");
        } else if (viewingMember) {
          setScreen("profile");
        } else {
          setScreen("family");
          setActiveTab("wishlu");
        }
      }
    }}>🗑️</button>
  )}
  <button className="btn btn-negro" disabled={uploading} onClick={function() {
            if (prevViewingMember) {
              setViewingMember(prevViewingMember);
              setViewingWishlist(prevViewingWishlist);
              setPrevViewingMember(null);
              setPrevViewingWishlist(null);
              setScreen("profile");
            } else if (viewingMember) {
              setScreen("profile");
            } else {
              setScreen("family");
              setActiveTab("wishlu");
            }
          }}>{tr("cancel")}</button>
        </div>
      </div>
    </div>
  );
}
